import { SxProps } from '@mui/material';

export const fieldControlStyles: SxProps = {
  padding: '0px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};
